import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Switch, Route, Link, NavLink } from "react-router-dom";
import productsData from '../data/products.json';
import { HashLink } from 'react-router-hash-link';
import { useNavigate } from "react-router-dom";

const Header = () => {
  const [products, setProducts] = useState(productsData || []);

  const [scrolling, setScrolling] = useState(false);
  const [scrollTop, setScrollTop] = useState(100);
  const navigate = useNavigate();

  const [resetSearch, setResetSearch] =useState(false);

  const [searchIndex, setSearchIndex] = useState([]);

  const [toggleHamMenu, setToggleHamMenu] = useState(false);

  const [headerHeight, setHeaderHeight] = useState({ height: '128px', transition: '0.2s' });
  const [navPadding, setNavPadding] = useState({ paddingTop: '4rem', transition: '0.2s' });
  const [logoHeight, setLogoHeight] = useState({ height: '12rem', transition: '0.2s' });

  const [showSearch, setShowSearch] = useState(false);
  const [showSearchBoxMobile, setShowSearchBoxMobile] = useState(false);
  const [searchValue, setSearchValue] = useState('');

  const hamStyles = {
    rotateNeg: {
      transform: "translate(0, 12px) rotate(-45deg)"
    },
    rotatePos: {
      transform: "translate(0, -4px) rotate(45deg)"
    },
    hide: {
      opacity: "0"
    }
  }

  const prepareSearchIndex = () => {
    let indexArray = [];
    Object.keys(products).forEach(productKey => {
      const product = products[productKey];
      let si = iterateProductRange(product.range.data, productKey);
      indexArray = [...indexArray, ...si];
    });
    console.log("indexArray -- ", indexArray);
    setSearchIndex(indexArray);
  }

  const iterateProductRange = (data, productKey) => {
    let subIndexArray = [];
    Object.keys(data).forEach(subProduct => {
      if (typeof data[subProduct] != 'object') {
        subIndexArray.push({ key: subProduct, path: '/product/' + productKey });
      } else {
        let ssi = iterateProductRange(data[subProduct], productKey)
        subIndexArray = [...subIndexArray, ...ssi]
      }
    })
    return subIndexArray;
  }

  useEffect(() => {
    searchBlur();
    prepareSearchIndex();
  },[resetSearch]);

  useEffect(() => {
    const onScroll = e => {
      setScrollTop(e.target.documentElement.scrollTop);
      setScrolling(e.target.documentElement.scrollTop > scrollTop);
      if (scrolling) {
        setHeaderHeight((prevState) => ({ ...prevState, height: '88px' }));
        setNavPadding((prevState) => ({ ...prevState, paddingTop: '2rem' }));
        setLogoHeight((prevState) => ({ ...prevState, height: '8rem' }));
      } else {
        setHeaderHeight((prevState) => ({ ...prevState, height: '128px' }));
        setNavPadding((prevState) => ({ ...prevState, paddingTop: '4rem' }));
        setLogoHeight((prevState) => ({ ...prevState, height: '12rem' }));
      }
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [scrollTop, scrolling, toggleHamMenu]);

  const searchFocus = () => {
    setShowSearch(true);
  }

  const searchBlur = () => {
    setShowSearch(false)
  }

  const handleSearch = (item) => {    
    setSearchValue(item.key);
    searchBlur();
    navigate(item.path);
  }

  const filterProducts = (e) => {
    const searchKey = e.target.value;
    setSearchValue(searchKey);
    if(searchKey.trim() === '') {
      setResetSearch(true);
      searchBlur();
    } else {
      searchFocus();
      setResetSearch(false);
      let tempArr=[];
      let subIndexArray = [];
      Object.keys(products).forEach(productKey => {
        const product = products[productKey];
        let si = iterateProductRange(product.range.data, productKey);
        subIndexArray = [...subIndexArray, ...si];
      });
      
      for(let item of subIndexArray) {
        if(item.key.toString().toLowerCase().indexOf(searchKey.toLowerCase()) > -1) {
          tempArr.push(item);
        }
      }
      if(tempArr.length === 0) {
        tempArr.push({ key: "No products found", disableClick: true})
      } 
      setSearchIndex(tempArr);
    }
  }

  const hideSearchMobile = (e)=>{
    const searchKey = e.target.value;
    if(searchKey.trim() === '') {
      setShowSearchBoxMobile(false);
      searchBlur();
    }
  }

  

  return (
    <>
      <header className="fixed top-0 z-50 shadow-xl bg-dinshaw-theme dinshaw-header hidden lg:grid" style={headerHeight}>
        <div className='absolute pl-4  lg:pl-16'>
          <Link to="/"><img className='dinshaw-logo' src="/dinshaws-logo-footer.jpg" style={logoHeight}></img></Link>
        </div>


        <nav className='relative dinshaw-nav text-slate-200 font-heading md:text-base lg:text-lg lg:grid hidden' style={navPadding}>
          <NavLink to="/about-us" className={({ isActive }) =>
            isActive ? 'font-bold nav-link relative' : ''
          }>
            <span className=" hover:font-bold">About Us</span>
          </NavLink>
          <div className='group'>
            <NavLink to="/products" className={({ isActive }) =>
              isActive ? 'font-bold nav-link relative' : ''
            }>
              <span className=" hover:font-bold" >Products</span>
            </NavLink>
            <div className="absolute z-10 hidden group-hover:block">
              <div className="-m-6 mt-4 pr-2 pt-2 pb-4 rounded-md bg-dinshaw-theme w-40 shadow-xl" >
                {
                  Object.keys(products).map(productId => (
                    <Link to={"/product/" + productId} >
                      <div className="p-1 pl-6 hover:text-white hover:underline ">
                        <span className="text-base">
                          {products[productId].name}
                        </span>
                      </div>
                    </Link>
                  ))
                }
              </div>
            </div>
          </div>
          <NavLink to="/legacy" className={({ isActive }) =>
            isActive ? 'font-bold nav-link relative' : ''
          }><span className="hover:font-bold">Our Legacy</span></NavLink>
          <NavLink to="/careers" className={({ isActive }) =>
            isActive ? 'font-bold nav-link relative' : ''
          }><span className=" hover:font-bold">Careers</span></NavLink>
          <NavLink to="/contact-us" className={({ isActive }) =>
            isActive ? 'font-bold nav-link relative' : ''
          }><span className=" hover:font-bold">Business Enquiry</span></NavLink>
          <div className='flex relative'>
            <input type="search" className="form-control dinshaw-search" placeholder="Search" aria-label="Search Products" onInput={filterProducts} value={searchValue}/>
            <span className="input-group-text flex absolute left-44 items-center px-3 py-2 top-1 text-base font-normal text-slate-200 text-center whitespace-nowrap rounded">
              <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="search" className="w-4" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path fill="currentColor" d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"></path>
              </svg>
            </span>
            {
              showSearch && <div className='absolute top-10 bg-white text-black w-full text-sm overflow-y-scroll h-auto max-h-80'>
                <ul className='mx-1 my-2'>
                  {
                    
                    searchIndex.length && searchIndex.map(pList => {
                      if(pList.disableClick) {
                        return <li className='truncate p-3 hover:bg-gray-100 text-gray-600' key={pList.key} >{pList.key}</li>
                      } else 
                      return <li className='truncate p-3 hover:bg-gray-100' key={pList.key} onClick={() => handleSearch(pList)}>{pList.key}</li>
                    })
                      
                      
                    
                  }
                </ul>
              </div>
            }
          </div>
          {/* <div className='justify-self-start'>
            <HashLink to="/contact-us#enquiry"><img src="/assets/static/images/Home page-04.png" className='h-5 w-8'></img></HashLink>
          </div> */}
        </nav>
      </header>

      <header className="fixed top-0 left-0 right-0 z-50 shadow-xl bg-dinshaw-theme dinshaw-header h-16 lg:hidden">
        <Link to="/"><img className='absolute dinshaw-logo pl-4 sm:ml-8 h-28 w-24' src="/dinshaws-logo-footer.jpg"></img></Link>
        <nav className='flex dinshaw-menu justify-end items-center pt-2'>
          <div className=''>
            {
              !showSearchBoxMobile && <img src="/assets/static/images/Home page-05.png" className='h-5 w-5 mx-3 text-white' onClick={() => setShowSearchBoxMobile(true)}></img>
            }
            {
              showSearchBoxMobile && <>
                  <div className='flex absolute right-16 top-3'>
                    <input type="search" className="form-control dinshaw-search w-52" placeholder="Search" aria-label="Search Products" onBlur={hideSearchMobile} onInput={filterProducts} value={searchValue}/>
                  
                    {
                      showSearch && <div className='absolute top-10 bg-white text-black w-full text-sm overflow-y-scroll h-auto max-h-80'>
                        <ul className='mx-1 my-2'>
                          {
                            
                            searchIndex.length && searchIndex.map(pList => {
                              if(pList.disableClick) {
                                return <li className='truncate p-3 hover:bg-gray-100 text-gray-600' key={pList.key} >{pList.key}</li>
                              } else 
                              return <li className='truncate p-3 hover:bg-gray-100' key={pList.key} onClick={() => handleSearch(pList)}>{pList.key}</li>
                            })
                              
                              
                            
                          }
                        </ul>
                      </div>
                    }
                  </div>
              </>
            }
            
          </div>
          {/* <div className=''>
            <HashLink to="/contact-us#enquiry">
              <img src="/assets/static/images/Home page-04.png" className='h-4 w-6 mx-3 text-white'></img>
            </HashLink>
          </div> */}
          <div className='hm-container mx-4' onClick={() => setToggleHamMenu(!toggleHamMenu)}>
            <div className="bar1" style={toggleHamMenu ? hamStyles.rotateNeg : {}}></div>
            <div className="bar2" style={toggleHamMenu ? hamStyles.hide : {}}></div>
            <div className="bar3" style={toggleHamMenu ? hamStyles.rotatePos : {}}></div>
          </div>
        </nav>
        {
          toggleHamMenu &&
          <nav className='mt-4 dinshaw-nav text-base text-slate-200 font-heading'>
            <Link to="/about-us">
              <span className="hover:font-bold" onClick={() => setToggleHamMenu(!toggleHamMenu)}>About Us</span>
            </Link>
            <div>
              <Link to="/products">
                <span className=" hover:font-bold" onClick={() => setToggleHamMenu(!toggleHamMenu)}>Products</span>
              </Link>
            </div>
            <Link to="/legacy"><span className="hover:font-bold" onClick={() => setToggleHamMenu(!toggleHamMenu)}>Our Legacy</span></Link>
            <Link to="/careers"><span className=" hover:font-bold" onClick={() => setToggleHamMenu(!toggleHamMenu)}>Careers</span></Link>
            <Link to="/contact-us"><span className=" hover:font-bold" onClick={() => setToggleHamMenu(!toggleHamMenu)}>Business Enquiry</span></Link>
          </nav>
        }
      </header>
    </>
  )
};
export default Header;

